const getServiceProvider = (state, payload) => {
  state.serviceProviderList = payload.data;
}



export default {
  getServiceProvider
}


// WEBPACK FOOTER //
// ./src/store/modules/serviceProvider/mutations.js